export default __webpack_public_path__ + "locales/lo-LA/Files.json?hash=d7734f4a7639dad792e3b0d0c66822e3";